module.exports = "/static/assets/7d3dd7098c7f0f16ebd370cfeb1161e9.png";